var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"scroll-area-wrapper",class:{'fade' : _vm.fadeVisible}},[_c('vue-custom-scrollbar',{staticClass:"scroll-area",attrs:{"settings":_vm.settings},on:{"ps-scroll-up":_vm.scrollUp,"ps-y-reach-end":_vm.reachedEnd}},[_vm._t("default")],2)],1)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c5ad5880","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Elements/CustomScrollbar.vue
// module id = null
// module chunks = 